import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about-section" }

import { h, computed } from "vue";
import CustomText from "@/components/common/CustomText.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutSection',
  props: {
    about: {}
  },
  setup(__props: any) {

const props = __props;

const aboutContent = computed(() => {
  return props.about;
});

// Custom components for minimalist about styling
const customTextComponents = {
  block: {
    normal: (_: unknown, { slots }: { slots: { default?: () => unknown } }) => {
      return h(
        "p",
        {
          class:
            "text-base text-stone-600 dark:text-stone-400 leading-relaxed mb-4 last:mb-0",
        },
        slots.default?.()
      );
    },
    h2: (_: unknown, { slots }: { slots: { default?: () => unknown } }) => {
      return h(
        "h2",
        {
          class:
            "font-display text-2xl font-bold text-stone-900 dark:text-stone-100 mb-4",
        },
        slots.default?.()
      );
    },
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomText, {
      value: aboutContent.value,
      components: customTextComponents
    }, null, 8, ["value"])
  ]))
}
}

})